/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/ViewManager
 * @desc Dropdown to switch between type of views on ExperimentWorkflow Index Screen
 */

import { ExperimentWorkflowViewManagerSelect } from 'labstep-web/components/ExperimentWorkflow/ViewManager/Select';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { ParamsContext } from 'labstep-web/contexts/params';
import { Icon } from 'labstep-web/core/Icon';
import { ParamsHOC } from 'labstep-web/hoc/Params';
import type React from 'react';
import type {
  ExperimentWorkflowTableViewOptionsProps,
  ExperimentWorkflowViewManagerContainerProps,
  ExperimentWorkflowViewManagerProps,
} from './types';

export const getViewOption = (viewType: string) => {
  if (viewType === 'list') {
    return viewOptions[0];
  }
  if (viewType === 'grid') {
    return viewOptions[1];
  }
  if (viewType === 'timeline') {
    return viewOptions[2];
  }
  return viewOptions[0];
};

export const viewOptions: ExperimentWorkflowTableViewOptionsProps[] =
  [
    {
      value: 'list',
      label: (
        <p>
          <Icon name="list alternate outline" /> List View
        </p>
      ),
    },
    {
      value: 'grid',
      label: (
        <p>
          <Icon name="table" /> Grid View
        </p>
      ),
    },
    {
      value: 'timeline',
      label: (
        <p>
          <Icon name="calendar alternate" /> Timeline View
        </p>
      ),
    },
  ];

export const ExperimentWorkflowViewManager: React.FC<
  ExperimentWorkflowViewManagerProps
> = ({ setUiExperimentWorkflowView, clearAll, uiPersistent }) => (
  <ExperimentWorkflowViewManagerSelect
    value={getViewOption(uiPersistent.experiment_workflow_view)}
    options={viewOptions}
    onChange={(value) => {
      setUiExperimentWorkflowView(value);
      if (value === 'grid') {
        clearAll();
      }
    }}
  />
);

export const ExperimentWorkflowViewManagerContainer: React.FC<
  ExperimentWorkflowViewManagerContainerProps
> = (props) => {
  return (
    <ParamsHOC historyAction="replace">
      <ParamsContext.Consumer>
        {({ clearAll }) => (
          <ExperimentWorkflowViewManager
            clearAll={clearAll}
            {...props}
          />
        )}
      </ParamsContext.Consumer>
    </ParamsHOC>
  );
};

export default withAuthenticatedUserEntity(
  withUiPersistent(ExperimentWorkflowViewManagerContainer),
);
